import { render, staticRenderFns } from "./Block4Item.vue?vue&type=template&id=668d2692&scoped=true&"
import script from "./Block4Item.vue?vue&type=script&lang=js&"
export * from "./Block4Item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668d2692",
  null
  
)

export default component.exports